import styled from 'styled-components';

const FareIndicator = styled.span`
  display: inline-block;
  background: black;
  border-radius: 100px;
  width: 8px;
  height: 8px;
`;

FareIndicator.displayName = 'FareIndicator';

export default FareIndicator;
